import { useEffect, useState } from "react";
import { getTokenData, isAuthenticated } from "security";

export interface UserData {
  email: string;
  role: UserRole;
  isAuthenticated: boolean;
  permissions: string[];
  providerDataOrigin: "G4S" | "EXTERNAL" | "UNKNOWN";
}

export enum UserRole {
  ADMINISTRADOR = "Administrador",
  SUPERVISOR = "Supervisor",
  OPERADOR = "Operador",
  AUDITOR_FISCAL = "Auditor fiscal",
}

export function getUserRole(userRole: string): UserRole {
  const roleMap: Record<string, UserRole> = {
    ADMINISTRATOR: UserRole.ADMINISTRADOR,
    SUPERVISOR: UserRole.SUPERVISOR,
    OPERATOR: UserRole.OPERADOR,
  };

  return roleMap[userRole] || UserRole.AUDITOR_FISCAL;
}

const useLoggedUser = (): UserData => {
  const [userInfo, setUserInfo] = useState<UserData>({
    email: "",
    role: UserRole.AUDITOR_FISCAL,
    isAuthenticated: false,
    permissions: [],
    providerDataOrigin: "UNKNOWN",
  });

  useEffect(() => {
    const fetchUserInfo = () => {
      try {
        const authenticated = isAuthenticated();

        if (!authenticated) {
          setUserInfo({
            email: "",
            role: getUserRole(""),
            isAuthenticated: false,
            permissions: [],
            providerDataOrigin: "UNKNOWN",
          });
          return;
        }

        const tokenData = getTokenData() as {
          userEmail: string;
          userRole: string;
          permissions: string[];
          providerDataOrigin: "G4S" | "EXTERNAL" | "UNKNOWN";
        };

        setUserInfo({
          email: tokenData.userEmail || "",
          role: getUserRole(tokenData.userRole || ""),
          isAuthenticated: true,
          permissions: tokenData.permissions,
          providerDataOrigin: tokenData.providerDataOrigin,
        });
      } catch (error) {
        console.error("Error getting user info:", error);
        setUserInfo({
          email: "",
          role: getUserRole(""),
          isAuthenticated: false,
          permissions: [],
          providerDataOrigin: "UNKNOWN",
        });
      }
    };

    fetchUserInfo();
  }, []);

  return userInfo;
};

export default useLoggedUser;
